(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Hero background settle ---- */
  var hero = document.getElementById("hero");
  if (hero) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add("is-ready"); });
    });
  }

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll(".reveal, .reveal-blur");
  if (reduce || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
    // Reveal anything already in view on load (hero) next frame
    requestAnimationFrame(function () {
      revealEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92 && r.bottom > 0) el.classList.add("in");
      });
    });
  }

  /* ---- Process carousel ---- */
  var BASE = "assets/coming-soon/";
  var slides = [
    { img: "sketch-1.jpg", pos: "50% 50%", label: "The collection line-up" },
    { img: "sketch-2.jpg", pos: "50% 50%", label: "Slip dress — flats & construction" },
    { img: "sketch-3.jpg", pos: "50% 50%", label: "Technical detailing" },
    { img: "journey-maker.jpg", pos: "50% 28%", label: "The mood board, Guangzhou" },
    { img: "journey-sample.jpg", pos: "50% 42%", label: "First sample fitting" }
  ];
  var stage = document.getElementById("stage");
  var thumbsWrap = document.getElementById("thumbs");
  var counter = document.getElementById("counter");
  var current = 0;

  if (stage && thumbsWrap && counter) {
    slides.forEach(function (s, i) {
      var t = document.createElement("button");
      t.className = "cs-thumb" + (i === 0 ? " is-active" : "");
      t.style.backgroundImage = "url('" + BASE + s.img + "')";
      t.style.backgroundPosition = s.pos;
      t.setAttribute("aria-label", "View " + s.label);
      t.addEventListener("click", function () { go(i); });
      thumbsWrap.appendChild(t);
    });

    function pad(n) { return (n < 10 ? "0" : "") + n; }

    function render() {
      stage.style.opacity = "0";
      window.setTimeout(function () {
        var s = slides[current];
        stage.style.backgroundImage = "url('" + BASE + s.img + "')";
        stage.style.backgroundPosition = s.pos;
        stage.style.opacity = "1";
      }, reduce ? 0 : 220);
      var thumbs = thumbsWrap.querySelectorAll(".cs-thumb");
      thumbs.forEach(function (el, i) { el.classList.toggle("is-active", i === current); });
      counter.textContent = pad(current + 1) + " / " + pad(slides.length) + " — " + slides[current].label;
    }

    function go(i) { current = (i + slides.length) % slides.length; render(); }

    document.querySelectorAll(".cs-arrow").forEach(function (btn) {
      btn.addEventListener("click", function () { go(current + parseInt(btn.getAttribute("data-dir"), 10)); });
    });

    render();
  }

  /* ---- Founder note video: click to play with sound ---- */
  var fVideo = document.querySelector(".cs-founder__video");
  var fPlay = document.querySelector(".cs-founder__play");
  if (fVideo && fPlay) {
    fPlay.addEventListener("click", function () {
      if (fVideo.ended) fVideo.currentTime = 0;
      fVideo.setAttribute("controls", "");
      fVideo.play();
      fPlay.classList.add("is-hidden");
    });
    fVideo.addEventListener("ended", function () {
      fVideo.removeAttribute("controls");
      fPlay.classList.remove("is-hidden");
    });
  }
    var startBgVideos = function () {
    document.querySelectorAll("video[autoplay]").forEach(function (v) {
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  };
  startBgVideos();
  ["pointerdown", "scroll", "touchstart", "keydown"].forEach(function (e) {
    window.addEventListener(e, startBgVideos, { once: true, passive: true });
  });
})();
